export const newsConstants = {
  // GET_ALL: 取得所有公告
  GET_ALL_REQUEST: "NEWS_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "NEWS_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "NEWS_GET_ALL_FAILURE",
  RESET_ALL_SUCCESS: "NEWS_RESET_ALL_SUCCESS",
  // CREATE_NEWS: 建立公告
  CREATE_NEWS_REQUEST: "NEWS_CREATE_NEWS_REQUEST",
  CREATE_NEWS_DONE: "NEWS_CREATE_NEWS_DONE",
  // GET_TYPE_OPTIONS: 取得公告類型選項
  GET_TYPE_OPTIONS_REQUEST: "NEWS_GET_TYPE_OPTIONS_REQUEST",
  GET_TYPE_OPTIONS_SUCCESS: "NEWS_GET_TYPE_OPTIONS_SUCCESS",
  GET_TYPE_OPTIONS_FAILURE: "NEWS_GET_TYPE_OPTIONS_FAILURE",
  RESET_TYPE_OPTIONS_SUCCESS: "NEWS_RESET_TYPE_OPTIONS_SUCCESS",
  // GET_HOUSEHOLD_READ_COUNT: 取得公告讀取數量
  GET_HOUSEHOLD_READ_COUNT_REQUEST: "NEWS_GET_HOUSEHOLD_READ_COUNT_REQUEST",
  GET_HOUSEHOLD_READ_COUNT_SUCCESS: "NEWS_GET_HOUSEHOLD_READ_COUNT_SUCCESS",
  GET_HOUSEHOLD_READ_COUNT_FAILURE: "NEWS_GET_HOUSEHOLD_READ_COUNT_FAILURE",
  RESET_HOUSEHOLD_READ_COUNT_SUCCESS: "NEWS_RESET_HOUSEHOLD_READ_SUCCESS",
  // DOWNLOAD_NEWS_ATTACHMENT: 下載公告附件
  DOWNLOAD_NEWS_ATTACHMENT_REQUEST: "NEWS_DOWNLOAD_NEWS_ATTACHMENT_REQUEST",
  DOWNLOAD_NEWS_ATTACHMENT_DOWN: "NEWS_DOWNLOAD_NEWS_ATTACHMENT_DOWN"
};
